import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

import './style.css';

export const LinkGroup = ({ className, label, children, onClick }) => {
    return (
        <div className={`${className ?? ''} link-group`}>
            <div className="link-group-label">{label}</div>
            <div className="link-group-links">
                {children &&
                    Array.isArray(children) &&
                    children.map((c) => <Link key={c.props.to} {...c.props} onClick={onClick} />)}
                {children && !Array.isArray(children) && children}
            </div>
        </div>
    );
};

const Link = ({ className, to, label, onClick, img, variant }) => {
    return (
        <div
            className={`link ${className ?? ''}`}
            data-variant={variant ?? ''}
            onClick={onClick ?? undefined}
            role="button"
            tabIndex={0}
        >
            <ReactRouterLink to={to}>
                {img}
                <span className="link-label">{label}</span>
            </ReactRouterLink>
        </div>
    );
};

export default Link;
